const moduletemplates = {
	title: "Modulmaler",
	new_moduletemplate: "Ny modulmal",
	edit_moduletemplate: "Rediger modulmal: {name}",
	view_moduletemplate: "Vis mal: {name}",
	list_title: "Vis modulmaler",
	list_subtitle: "Håndter modulmaler",
	create_title: "Opprett ny modulmal",
	update_title: "Oppdater modulmal",
	details_title: "Modulmal detaljer",
	id: "ID",
	name: "Navn",
	description: "Beskrivelse",
	req_hours: "Timer",
	req_module_id: "Påkrevd modul",
	req_coursetemplate_id: "Påkrevd kurs",
	type: "Type",
	template_type: "Maltype",
	price: "Pris",
	price_vat: "Pris m/MVA",
	status: "Status",
	is_included: "Inkludert?",
	is_joint: "Er felles?",
	mandatory: "Minst 1 skal velges",
	created_by: "Opprettet av",
	expand_button_view_course_types: "Vis kurstyper",
	expand_button_close_course_types: "Lukk",
	save_first: "Modulmal må bli lagret først",
	coursetype_id: "Kompetansetype",
	coursetypegroup_id: "Kompetanseområder",
	add_to_expertise: "Selvstendig kompetanse",
	internal_note: "Intern notat",
	duplicate_message: "Vil du opprette en kopi av valgt mal?",
	hide_in_accomplishment: "Skjul i progresjon",
	hide_in_enrolment: "Skjul i påmelding",
	hide_in_accomplishment_helptext: "Kryss av her hvis denne modulen ikke skal være inkludert i progresjon",
	required_module_course_helptext: "Her kan du definere avhengigheten mellom ulike emneelementer, som rekkefølgen på læringsfremdriften.",
	select_visibility: "Visningsvalg",
};
export default moduletemplates;